// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.descriptionColumn__bba.descriptionColumn__bba.descriptionColumn__bba {
  width: auto;
  text-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/feature-flags/feature-flags.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[".descriptionColumn.descriptionColumn.descriptionColumn {\n  width: auto;\n  text-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descriptionColumn": `descriptionColumn__bba`
};
export default ___CSS_LOADER_EXPORT___;
